import Loadable from "components/Loadable";
import {lazy} from "react";
import AttendanceBase from "../pages/attendance/AttendanceBase";
const LeaveTypes = Loadable(lazy(() => import('pages/attendance/leave-types/leave-types')));
const HrAttendance = Loadable(lazy(() => import('pages/attendance/hr/attendance/hr-attendance')));
const HrLeaveApplications = Loadable(lazy(() => import('pages/attendance/hr/leave-applications/hr-leave-application')));

const Attendance = {
    path: 'attendance',
    element: <AttendanceBase />,
    children: [
        // {
        //     path: '',
        //     element: <Dashboard />
        // },
        {
            path: 'leave-types',
            element: <LeaveTypes />
        },
        {
            path: 'attendance',
            element: <HrAttendance />
        },
        {
            path: 'leave-applications',
            element: <HrLeaveApplications />
        }
    ]}
export default Attendance;
